import React from 'react';
import Navbar from '../components/Navbar';
import Sidemenubar from '../components/Sidemenubar';
import { Outlet } from 'react-router-dom';

const AuthenticatedLayout = () => {
  return (
    <>
    <Navbar />
    <div className="d-flex content">
      <div className="sidenav">
        <Sidemenubar />
      </div>
      <div className="flex-grow-1 outletcard">
        <div className="page p-4">
          <Outlet />
        </div>
      </div>
    </div>
  </>
  
  );
};

export default AuthenticatedLayout;

